// SPEC_DEMO.md PR-5. Replaces <AnalysisPanel /> for demo site clicks.
// Shows a few teaser facts (name, voltage, lat/lon) and a CTA. The
// "blurred preview" CSS lives in demo.css.

import React from 'react';
import { track } from './demoTelemetry';

export default function LockedAnalysisPreview({ site, onClose }) {
  if (!site) return null;
  React.useEffect(() => {
    track('locked_panel_opened', { site_id: site.site_id });
  }, [site.site_id]);

  return (
    <div className="demo-locked-panel" role="dialog" aria-label="Locked analysis preview">
      <button
        className="demo-locked-close"
        onClick={onClose}
        aria-label="Close preview"
      >
        ×
      </button>

      <div className="demo-locked-header">
        <div className="demo-locked-title">{site.name}</div>
        <div className="demo-locked-meta">
          {site.voltage_kv ? `${site.voltage_kv} kV` : '— kV'}
          {' · '}
          {site.lat.toFixed(3)}°N {site.lon.toFixed(3)}°E
        </div>
      </div>

      {/* Blurred placeholder rows — visual hint that there's more data
          behind the paywall. CSS uses filter:blur to render the
          shapes; no real data is embedded in this DOM. */}
      <div className="demo-locked-blur">
        <div className="demo-locked-blur-row" />
        <div className="demo-locked-blur-row" />
        <div className="demo-locked-blur-row short" />
        <div className="demo-locked-blur-row" />
        <div className="demo-locked-blur-row short" />
      </div>

      <a
        className="demo-locked-cta"
        href="https://calendly.com/benjamin-respire/seidr"
        target="_top"
        rel="noopener noreferrer"
        onClick={() => track('cta_clicked', { location: 'locked_panel' })}
      >
        Book a demo for full analysis →
      </a>
    </div>
  );
}
